import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, MenuItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import LogoutIcon from '@mui/icons-material/ExitToApp';
import SettingsIcon from '@mui/icons-material/Settings';

import { useNavigationStack } from '../../../context/NavigationStackContext';
import { useFirebaseAuth } from '../../../hooks/useFirebaseAuth';
import { useGetMyDetails } from '../../../redux/api/users/usersApi';
import { resetState } from '../../../redux/store';
import { AvatarSize } from '../../../shared/constants';
import { Paths } from '../../../shared/paths';
import AppUserAvatar from '../app-entity-avatar/app-user-avatar/AppUserAvatar';
import AppMenu, { PositionOption, getPosition } from '../app-menu/AppMenu';
import { useStyles } from './AppProfileMenu.styles';

export default function AppProfileMenu(props) {
  //@ts-ignore
  const { data: user } = useGetMyDetails();
  const [anchorEl, setAnchorEl] = useState(null);
  const { logOut } = useFirebaseAuth();
  const { t } = useTranslation();
  const { navigate } = useNavigationStack();
  const theme = useTheme();

  const { classes } = useStyles(theme);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleMenuClose();
    await logOut();
    resetState();
    navigate(Paths.signIn);
  };

  return (
    <AppUserAvatar
      entity={user}
      size={AvatarSize.s}
      className={classes.avatar}
    />
  );

  // return (
  //   <AppMenu
  //     anchorEl={anchorEl}
  //     onClose={handleMenuClose}
  //     anchorOrigin={getPosition(PositionOption.bottom, PositionOption.right)}
  //     transformOrigin={getPosition(PositionOption.top, PositionOption.right)}
  //     className={classes.menuContainer}
  //     targetElement={
  //       <Box onClick={(e) => setAnchorEl(e.currentTarget)}>
  //         <AppUserAvatar
  //           entity={user}
  //           size={AvatarSize.s}
  //           className={classes.avatar}
  //         />
  //       </Box>
  //     }>
  //     <MenuItem
  //       className={classes.menuItem}
  //       onClick={() => {
  //         handleMenuClose(); // Close menu before navigating
  //         navigate(Paths.settings.toInfoView);
  //       }}>
  //       <SettingsIcon />
  //       {t('common.settings')}
  //     </MenuItem>
  //     <MenuItem className={classes.menuItem} onClick={handleLogout}>
  //       <LogoutIcon />
  //       {t('common.logOut')}
  //     </MenuItem>
  //   </AppMenu>
  // );
}
